import $ from 'jquery';
import _ from "underscore";
import collectDataAttributesFor from "../collectDataAttributesFor";
import {isTruthy} from "../general";

$(()=>{
  $(document).on("change", "select.quick-toggler", function(e){
    const el = $(e.target);
    quickToggle(el);
  });

  // $("input.quick-toggler").get(0).onchange = function(){
  //   console.log("ya");
  // };

  $(document).on("change", ".quick-toggler:checkbox, input[type='hidden'].quick-toggler", function(e){
    const el = $(e.target);
    quickToggle(el);
  });

  $(".quick-toggler").each(function(){
    quickToggle($(this), {initial: true});
  });
});


export default function quickToggle(el, {initial}={}){
  let togglables = $();
  let targetTogglable = $();
  const options = collectDataAttributesFor(el.get(0), {prefix: "quick-toggler"});
  if(el.is("select")){
    const optionEls = el.find("option");
    const selectedOption = optionEls.filter(':selected');
    togglables = collectTogglablesFor(optionEls);
    togglables = collectVisible(togglables);
    targetTogglable = collectTogglablesFor(selectedOption);
    let speed = parseInt(options.speed, 10);
    if(!_.isNumber(speed)){
      speed = 100;
    }
    animateOpacity(togglables, 0, speed, function(){
      animateOpacity(targetTogglable, 1, speed);
    });


  }
  else if(el.is(":checkbox")){
    togglables = getTarget(el, options);
    if (isTruthy(options.showOnChecked)) {
      if(el.is(":checked")){
        animateOpacity(togglables, 1);
      }
      else{
        animateOpacity(togglables, 0);
      }
    }
    if (isTruthy(options.showOnUnchecked)) {
      if(el.is(":checked")){
        animateOpacity(togglables, 0);
      }
      else{
        animateOpacity(togglables, 1);
      }
    }
  }

  else if(el.is("input[type='hidden']")){
    togglables = getTarget(el);
    
    if(options.showWhenEq === el.val()){
      animateOpacity(togglables, 1);
    }
    else{
      animateOpacity(togglables, 0);
    }

  }
}

function getTarget(el, options={}){
  let togglables;
  if(options.closest){
    togglables = el.closest(options.closest).find(options.target);
  }
  else{
    togglables = collectTogglablesFor(el);
  }
  return togglables;
}

function collectTogglablesFor(els){
  let togglables = $();
  els.each(function(){
    const el = $(this);
    const target = $(el.data("quick-toggler-target"));
    togglables = togglables.add(target);
  });
  return togglables;
}

function collectVisible(els){
  let visibleEls = $();
  els.each(function(){
    const el = $(this);
    if(el.is(":visible")){
      visibleEls = visibleEls.add(el);
    }
  });
  return visibleEls;
}


// export function animateElementsOpacity([firstOptions, secondOptions], cb=()=>{}){
//   const {element, speed, opacity} = firstOptions;

//   animateOpacity(element, opacity, speed, ()=>{
//     const {element, speed, opacity} = secondOptions;
//       animateOpacity(element, opacity, speed, cb);
//   });
// }


function animateOpacity(el, opacity=1, speed=100, cb=()=>{}){
  if(el.length){
    let startCss = {};
    let endCssDisplay;

    if(opacity === 1){
      startCss = {display: "", opacity: 0};
      endCssDisplay = "";

    }else{
      startCss = {display: ""};
      endCssDisplay = "none";
    }


    el.css(startCss);

    el.animate({opacity}, speed, function(){
      el.css({display:endCssDisplay});
      cb();
    });
  }
  else{
    cb();
  }
}


// WEBPACK FOOTER //
// ./src/utilities/quickToggler/index.js